export default "__VITE_ASSET__C33xPE20__"